'use client';

import { FooterStoryblok } from '@/storyblok/types';
import FooterTop from '@/app/_components/layouts/footer/footerTop';
import FooterBottom from '@/app/_components/layouts/footer/footerBottom';
import dynamic from 'next/dynamic';
import { StoryblokStory } from 'storyblok-generate-ts';
import { useIsWelfare } from '@/app/_hooks/useIsWelfare';
import { FooterTheme } from '@/app/_components/layouts/footer';

const FooterTantosvago = dynamic(() => import('@/app/_components/layouts/footer/footerTantosvago'));

const FooterWrapper: React.FC<{
  story: StoryblokStory<FooterStoryblok> | undefined | null;
  storyTantoSvago: StoryblokStory<FooterStoryblok> | undefined | null;
  minimal: boolean;
  theme?: FooterTheme;
}> = ({ story, storyTantoSvago, minimal, theme }) => {
  const isWelfare = useIsWelfare();
  if (storyTantoSvago?.content?.component === 'Footer' && isWelfare) return <FooterTantosvago component={storyTantoSvago.content} />;

  if (story?.content?.component === 'Footer') {
    return (
      <>
        {!minimal && <FooterTop story={story} component={story.content} theme={theme} />}
        <FooterBottom story={story} component={story.content} minimal={minimal} theme={theme} />
      </>
    );
  }

  return null;
};

export default FooterWrapper;
